import React, { useState, useEffect } from "react";
import { Bell, Trash2, ToggleLeft, ToggleRight,UserPlus } from "lucide-react";

const AdminPage = () => {
  const [avisos, setAvisos] = useState([]);
  const [novoAviso, setNovoAviso] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [avisoIdToDelete, setAvisoIdToDelete] = useState(null);
  const [showToggleModal, setShowToggleModal] = useState(false);
  const [avisoIdToToggle, setAvisoIdToToggle] = useState(null);
  const [novoStatus, setNovoStatus] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [novoUsuario, setNovoUsuario] = useState({
    email: "",
    usuario: "",
    cpfCnpj: "",
    senha: "",
    telefone: "",
  });

  useEffect(() => {
    fetchAvisos();
    fetchUsuarios();
  }, []);

  const fetchAvisos = async () => {
    try {
      const response = await fetch("https://sismoney.com/painel/aviso.php?acao=buscar");
      const text = await response.text(); // Obtenha o texto bruto
      console.log("Resposta bruta:", text); // Verifique o que está sendo retornado
      const data = JSON.parse(text); // Agora tente analisar o JSON
      setAvisos(data);
    } catch (error) {
      console.error("Erro ao buscar aviso diário:", error);
    }
  };
  const fetchUsuarios = async () => {
    try {
      const response = await fetch("https://sismoney.com/painel/usuarios.php?acao=listar");
      const data = await response.json();
      setUsuarios(data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  const handleCriarAviso = async () => {
    try {
      const response = await fetch("https://sismoney.com/painel/aviso.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mensagem: novoAviso }),
      });
      const result = await response.json();
      if (result.success) {
        setNovoAviso("");
        fetchAvisos();
      } else {
        console.error("Erro ao criar aviso:", result.message);
      }
    } catch (error) {
      console.error("Erro ao criar aviso:", error);
    }
  };
  const handleCriarUsuario = async (e) => {
    e.preventDefault();
    try {
      await fetch("https://sismoney.com/painel/usuarios.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...novoUsuario, action: "register" }),
      });
      setNovoUsuario({ email: "", usuario: "",cpfCnpj: "", senha: "", telefone: "" });
      fetchUsuarios();
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
    }
  };
  
  const handleShowToggleModal = (id, ativo) => {
    setAvisoIdToToggle(id);
    setNovoStatus(ativo == 0 ? 1 : 0);  // Alteração aqui: === para comparação estrita
    setShowToggleModal(true);
  };
  
  const handleConfirmToggle = async () => {
    if (avisoIdToToggle !== null) {
      await handleToggleAtivo(avisoIdToToggle, novoStatus);
      setShowToggleModal(false);
    }
  };
  const handleDeletarAviso = async () => {
    try {
      const response = await fetch("https://sismoney.com/painel/aviso.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deletar: true, id: String(avisoIdToDelete) }),
      });

      const result = await response.json();
      if (result.success) {
        setShowModal(false);
        fetchAvisos();
      } else {
        console.error("Erro ao deletar aviso:", result.message);
      }
      window.location.reload()

    } catch (error) {
      console.error("Erro ao deletar aviso:", error);
    }
  };

  const handleToggleAtivo = async (id, ativo) => {
    try {
      console.log("Enviando requisição para alterar status...", { id, ativo });
  
      const response = await fetch("https://sismoney.com/painel/aviso.php", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, ativo }),
      });
  
      const responseText = await response.text(); // Pega a resposta bruta
      console.log("Resposta bruta do servidor:", responseText);
  
      const result = JSON.parse(responseText); // Converte para JSON
      console.log("Resposta JSON:", result);
  
      if (result.success) {
        fetchAvisos(); // Atualiza a lista
      } else {
        console.error("Erro ao alterar status do aviso:", result.message);
      }
      window.location.reload()

    } catch (error) {
      console.error("Erro ao alterar status do aviso:", error);
    }
  };

  return (
    <div className="min-h-screen p-4 flex flex-col gap-6">
      <div className="p-4 bg-white rounded-lg shadow">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <Bell /> Gerenciar Avisos
        </h2>
        <input
          type="text"
          placeholder="Digite um aviso"
          value={novoAviso}
          onChange={(e) => setNovoAviso(e.target.value)}
          className="border rounded p-2 w-full mt-2"
        />
        <button onClick={handleCriarAviso} className="w-full mt-2 bg-blue-500 text-white p-2 rounded">
          Criar Aviso
        </button>
        <ul className="mt-4">
          {avisos.length > 0 ? avisos.map((aviso) => (
      <li key={aviso.id} className="flex justify-between items-center p-2 bg-gray-100 rounded-lg mt-2">
        {aviso.mensagem}
        <div className="flex gap-2">
          <button
            onClick={() => handleShowToggleModal(aviso.id, aviso.ativo)}  // Exibe o modal de confirmação
            className={`text-white p-2 rounded ${aviso.ativo == 1 ? 'bg-green-500' : 'bg-yellow-500'}`}
          >
            {aviso.ativo == 1 ? <ToggleRight /> : <ToggleLeft />}
          </button>
          <button
            onClick={() => {
              setAvisoIdToDelete(aviso.id);
              setShowModal(true);
            }}
            className="bg-red-500 text-white p-2 rounded"
          >
            <Trash2 />
          </button>
        </div>
      </li>
    )) : <></>}

   


        </ul>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
          <UserPlus /> Cadastro de Usuários
        </h2>
        <form onSubmit={handleCriarUsuario} className="mt-4 space-y-4">
          <input type="email" name="email" placeholder="Email" className="w-full p-2 border rounded-lg" value={novoUsuario.email} onChange={(e) => setNovoUsuario({ ...novoUsuario, email: e.target.value })} required />
          <input type="text" name="usuario" placeholder="Usuário" className="w-full p-2 border rounded-lg" value={novoUsuario.usuario} onChange={(e) => setNovoUsuario({ ...novoUsuario, usuario: e.target.value })} required />
          <input type="password" name="senha" placeholder="Senha" className="w-full p-2 border rounded-lg" value={novoUsuario.senha} onChange={(e) => setNovoUsuario({ ...novoUsuario, senha: e.target.value })} required />
          <input type="cpfCnpj" name="cpfCnpj" placeholder="CPF" className="w-full p-2 border rounded-lg" value={novoUsuario.cpfCnpj} onChange={(e) => setNovoUsuario({ ...novoUsuario, cpfCnpj: e.target.value })} required />
          <input type="tel" name="telefone" placeholder="Telefone" className="w-full p-2 border rounded-lg" value={novoUsuario.telefone} onChange={(e) => setNovoUsuario({ ...novoUsuario, telefone: e.target.value })} required />
          <button type="submit" className="w-full bg-indigo-600 text-white p-2 rounded-lg hover:bg-indigo-700">Cadastrar</button>
        </form>
      </div>

      {/* Modal de Confirmação */}
      {showModal && (
  <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center px-4">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm sm:max-w-lg">
      <h3 className="text-lg font-bold mb-4 text-center">
        Tem certeza de que deseja deletar este aviso?
      </h3>
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <button 
          onClick={handleDeletarAviso} 
          className="bg-red-500 text-white px-6 py-2 rounded w-full sm:w-auto"
        >
          Confirmar
        </button>
        <button 
          onClick={() => setShowModal(false)} 
          className="bg-gray-500 text-white px-6 py-2 rounded w-full sm:w-auto"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
)}

{/* Modal de Confirmação para alternar o status */}
{showToggleModal && (
  <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center px-4">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm sm:max-w-lg">
      <h3 className="text-lg font-bold mb-4 text-center">
        Tem certeza de que deseja {novoStatus == 1 ? "ativar" : "desativar"} este aviso?
      </h3>
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <button 
          onClick={handleConfirmToggle} 
          className="bg-green-500 text-white px-6 py-2 rounded w-full sm:w-auto"
        >
          Confirmar
        </button>
        <button 
          onClick={() => setShowToggleModal(false)} 
          className="bg-gray-500 text-white px-6 py-2 rounded w-full sm:w-auto"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default AdminPage;
